import React from "react";
import { Mail, Phone, User } from "lucide-react";

const contacts = [
  {
    name: "Tormod",
    email: "tormod@telcofy.ai",
    phone: "+47 901 15 059",
    role: "CEO · co-founder",
    image: "/tormod_profile.jpeg",
    bio:
      "20+ years in management, innovation, business development, marketing and communication.",
  },
  {
    name: "Tom",
    email: "tom@telcofy.ai",
    phone: "+47 918 90 064",
    role: "CCO · co-founder",
    image: "/team/tom.jpg",
    bio:
      "20+ years commercial. Spent the last seven years building Nordic mobility-science sales and grew that market from zero to nine figures in regional revenue at his previous employer.",
  },
  {
    name: "Alexey",
    email: "alexey@telcofy.ai",
    role: "CTO · co-founder",
    image: "/pictures/alexey.jpg",
    bio:
      "Mobile-network data pipelines from PoC to MVP. GCP data engineering, ML engineering, CI/CD, SRE.",
  },
  {
    name: "David",
    email: "david@telcofy.ai",
    role: "COO · co-founder",
    image: "/pictures/david.jpeg",
    bio:
      "Seven years in mobility and location analytics. Senior data scientist who takes analytical ideas from notebook to shipping product, with a focus on telco-derived signals at national scale.",
  },
];

const ContactSection = () => {
  return (
    <section
      id="contact-section"
      className="relative py-24 bg-paper border-t border-paper-300"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-2xl mb-14">
          <p className="text-xs font-semibold tracking-widest text-brand-600 uppercase mb-3">
            Team
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-ink tracking-tight mb-4">
            Talk to the people building it.
          </h2>
          <p className="text-lg text-ink-muted leading-relaxed">
            Send a note. We typically reply within 24 hours and are happy to
            walk through a working demo.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {contacts.map((contact) => (
            <div
              key={contact.name}
              className="bg-paper border border-paper-300 rounded-lg p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-brand-card hover:border-brand-500/40"
            >
              <div className="flex items-start gap-5">
                <div className="w-16 h-16 rounded-full bg-paper-200 overflow-hidden flex-shrink-0 grid place-items-center">
                  <img
                    src={contact.image}
                    alt={`${contact.name}, ${contact.role}`}
                    className="w-full h-full object-cover"
                    style={{ objectPosition: contact.imagePosition || "center" }}
                    onError={(e) => {
                      e.target.style.display = "none";
                      e.target.nextElementSibling.style.display = "flex";
                    }}
                  />
                  <User
                    size={24}
                    className="text-ink-faint hidden"
                  />
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="font-display text-xl font-semibold text-ink leading-tight">
                    {contact.name}
                  </h3>
                  <p className="text-xs font-mono text-brand-700 uppercase tracking-wider mt-1">
                    {contact.role}
                  </p>
                  <p className="text-sm text-ink-muted leading-relaxed mt-3">
                    {contact.bio}
                  </p>

                  <div className="mt-4 pt-4 border-t border-paper-300 space-y-2">
                    {contact.email && (
                      <a
                        href={`mailto:${contact.email}`}
                        className="flex items-center gap-2.5 text-sm text-ink-soft hover:text-brand-600 transition-colors"
                      >
                        <Mail size={14} className="text-ink-subtle flex-shrink-0" />
                        <span className="truncate">{contact.email}</span>
                      </a>
                    )}
                    {contact.phone && (
                      <a
                        href={`tel:${contact.phone}`}
                        className="flex items-center gap-2.5 text-sm text-ink-soft hover:text-brand-600 transition-colors"
                      >
                        <Phone size={14} className="text-ink-subtle flex-shrink-0" />
                        <span>{contact.phone}</span>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
